export enum BusinessUnits {
  fans = 'Fans',
  louvers = 'LV',
  temperedAirProduct = 'ERV',
  makeUpAir = 'MUA',
  preconditioners = 'ERV',
}
